import React from 'react';
import type { MarkdownMentionPreviewContext } from '../types';

export const MentionPreviewContext = React.createContext<
  MarkdownMentionPreviewContext | undefined
>(undefined);
